module.exports = __webpack_public_path__ + "img/facebook_logo.b5fcf817.svg";